import { render, staticRenderFns } from "./v-questions.vue?vue&type=template&id=73f2977d&"
import script from "./v-questions.vue?vue&type=script&lang=js&"
export * from "./v-questions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports